<template>
  <div class="xh-wrap">
    <myImg
      img="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner3_1.jpg"
    ></myImg>
    <myTab
      :tab-list="tabList"
      @change="changeTab"
      :activeIndex="activeIndex"
      :bread-title="breadTitle"
      smallSize
    ></myTab>
    <template v-if="activeIndex == 0 && !videoDetail && !imgDetail.length">
      <b-container>
        <b-row>
          <b-col md="6" lg="4" v-for="(v, i) in imgList" :key="i">
            <div
              class="item mt-40 text-center"
              v-if="i < 9"
              @click="handleShowImgDetail(v)"
            >
              <img :src="v.img" height="230px" :alt="v.alt" />
              <div class="mt-20 color-fff fs-24">{{ v.title }}</div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template v-if="activeIndex == 1 && !videoDetail && !imgDetail.length">
      <b-container>
        <b-row>
          <b-col md="6" lg="4" v-for="(v, i) in mockVideoList" :key="i">
            <div
              class="item mt-40 text-center"
              v-if="i < 9"
              @click="handleShowVideoDetail(v)"
            >
              <div class="img-wrap pr">
                <img :src="v.poster" height="230px" :alt="v.alt" />
                <img class="pa icon" src="@/assets/img/icon_play.png" />
                <div class="overlay"></div>
              </div>
              <div class="mt-20 color-fff fs-24">{{ v.title }}</div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template v-if="videoDetail">
      <div class="container text-center">
        <div class="fs-24 bold color-fff mt-60 mb-30">
          {{ videoDetail.title }}
        </div>
        <div class="fs-14 color-ccc mb-40">{{ videoDetail.desc }}</div>
        <video class="mb-60" controls :src="videoDetail.src"></video>
      </div>
    </template>
    <template v-if="imgDetail.length">
      <b-container class="mb-40">
        <b-row>
          <b-col md="6" lg="4" v-for="(v, i) in imgDetail" :key="i">
            <div class="item mt-40">
              <img v-lazy="v.img" height="230px" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <div
      v-if="!videoDetail && !imgDetail.length"
      class="container text-center mt-30 mb-30"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page="pageNo"
        :limit="9"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <page-Footer></page-Footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageFooter from "@/components/pageFooter";
import myImg from "@/components/myImg";
import myTab from "@/components/myTab";
export default {
  components: {
    pageTop,
    pageFooter,
    myImg,
    myTab,
  },
  data() {
    return {
      tabList: [
        {
          title: this.$t("review.photo"),
          en: "Photo",
        },
        // {
        //   title:"视频",
        //   en:"Video"
        // }
      ],
      activeIndex: 0,
      breadTitle: {
        cn: this.$t("review.title"),
        en: "Review",
      },
      pageNo: 1,
      mockImgList: [
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_23_1.jpg",
          title: this.$t("review.23rd"),
          order: 23,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_22_1.jpg",
          title: this.$t("review.22nd"),
          order: 22,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_21_1.jpg",
          title: this.$t("review.21st"),
          order: 21,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_20_1.jpg",
          title: this.$t("review.20th"),
          order: 20,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_19_1.jpg",
          title: this.$t("review.19th"),
          order: 19,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_18_1.jpg",
          title: this.$t("review.18th"),
          order: 18,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_17_1.jpg",
          title: this.$t("review.17th"),
          order: 17,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_16_1.jpg",
          title: this.$t("review.16th"),
          order: 16,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_15_1.jpg",
          title: this.$t("review.15th"),
          order: 15,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_14_1.jpg",
          title: this.$t("review.14th"),
          alt: "第十四届广州汽车展",
          order: 14,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_13_1.jpg",
          title: this.$t("review.13rd"),
          order: 13,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_12_1.jpg",
          title: this.$t("review.12nd"),
          order: 12,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_11_1.jpg",
          title: this.$t("review.11st"),
          order: 11,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_10.jpg",
          title: this.$t("review.10th"),
          order: 10,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_9.jpg",
          title: this.$t("review.9th"),
          order: 9,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_8.jpg",
          title: this.$t("review.8th"),
          order: 8,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_7.jpg",
          title: this.$t("review.7th"),
          order: 7,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_6.jpg",
          title: this.$t("review.6th"),
          order: 6,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_5.jpg",
          title: this.$t("review.5th"),
          order: 5,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_4.jpg",
          title: this.$t("review.4th"),
          order: 4,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_3.jpg",
          title: this.$t("review.3rd"),
          order: 3,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_2.jpg",
          title: this.$t("review.2nd"),
          order: 2,
        },
        {
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_1.jpg",
          title: this.$t("review.1st"),
          order: 1,
        },
      ],
      mockVideoList: [
        {
          src: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_19_video.mp4",
          title: "第十九届广州汽车展",
          desc: "发布时间: 2018-09-21:14:12",
          poster:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_19.jpg",
        },
      ],
      imgList: [],
      videoList: [],
      videoDetail: null,
      imgDetail: [],
    };
  },
  computed: {
    total() {
      return this.activeIndex == 0
        ? this.mockImgList.length
        : this.mockVideoList.length;
    },
  },

  watch: {
    pageNo(newv, oldv) {
      if (newv == 1) {
        this.reset();
      } else if (newv > 1) {
        if (this.activeIndex == 0) {
          this.imgList = this.mockImgList.filter(
            (i, v) => v >= oldv * 9 && v <= newv * 9,
          );
        } else {
          this.videoList = this.mockVideoList.filter(
            (i, v) => v >= oldv * 9 && v <= newv * 9,
          );
        }
      }
      window.scroll(0, 0);
    },
  },
  mounted() {
    if (this.mockImgList.length) {
      this.imgList =
        this.mockImgList.length > 9
          ? this.mockImgList.filter((i, v) => v < 9)
          : this.mockImgList;
    }
    if (this.mockVideoList.length) {
      this.videoList =
        this.mockVideoList.length > 9
          ? this.mockVideoList.filter((i, v) => v < 9)
          : this.mockVideoList;
    }
  },
  methods: {
    changeTab(index) {
      console.log(index);
      this.activeIndex = index;
      this.pageNo = 1;
      this.videoDetail = null;
      this.imgDetail = [];
      this.reset();
    },
    reset() {
      if (this.activeIndex == 0) {
        this.imgList = this.mockImgList.filter((i, v) => v < 9);
      } else {
        this.videoList = this.mockVideoList.filter((i, v) => v < 9);
      }
      window.scroll(0, 0);
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
    },
    handleShowVideoDetail(detail) {
      this.videoDetail = detail;
    },
    handleShowImgDetail({ order }) {
      if (order === 1) return;
      this.imgDetail = require(`./jie${order}.js`).default;
      window.scroll(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.item:hover {
  cursor: pointer;
  > div {
    color: #42abff;
  }
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
}
.icon {
  position: absolute;
  z-index: 100;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
}
video {
  width: 80%;
}
@media screen and (min-width: 100px) and (max-width: 1000px) {
  .icon {
    width: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7095b09e